import {
	GET_EXPORT_CONTENT,
	PARSE_XML_NODES,
	CHANGE_EXPORT_FILE,
	START_OVER,
	UPDATE_SELECTED_PAGES,
	SHOW_DRAFT_PAGES,
	SHOW_PUBLISHED_PAGES
} from './constants';

import {
	getXMLfromString,
	getXMLNodes
} from './utilities';

const initialState = {
	exportFileContent: '',
	exportFile: '',
	isExportFileSelected: false,
	hasBeenRead: false,
	menuXMLContent: '',
	menuNodes: '',
	menuTermNodes: '',
	authorNodes: '',
	pageNodes: '',
	postNodes: '',
}

const initialSelectionState = {
	selectedPageIds: [],
	isDraftShown: true,
	isPublishedShown: true,
}

export const parseExportFile = (state=initialState, action={}) => {

	switch (action.type) {

		case GET_EXPORT_CONTENT:

			return { ...state, exportFileContent: action.payload, hasBeenRead: true }

		case CHANGE_EXPORT_FILE:

			return { ...state, exportFile: action.payload, isExportFileSelected: true }

		case PARSE_XML_NODES:

			const xmlDoc = getXMLfromString(action.payload);

			return { ...state,
				menuNodes: getXMLNodes(xmlDoc, 'item', 'post_type', 'nav_menu_item'),
				menuTermNodes: getXMLNodes(xmlDoc, 'wp:term', 'term_taxonomy', 'nav_menu'),
				authorNodes: getXMLNodes(xmlDoc, 'wp:author', 'author_login', 'admin'),
				pageNodes: getXMLNodes(xmlDoc, 'item', 'post_type', 'page'),
				postNodes: getXMLNodes(xmlDoc, 'item', 'post_type', 'post'),
			}

		case START_OVER:

			return { ...state, isExportFileSelected: false, hasBeenRead: false }

		default:

			return state;
	}
}

export const updateSelection = (state=initialSelectionState, action={}) => {

	switch (action.type) {

		case UPDATE_SELECTED_PAGES:

			return { ...state, selectedPageIds: action.payload}

		case SHOW_DRAFT_PAGES:

			return { ...state, isDraftShown: action.payload }

		case SHOW_PUBLISHED_PAGES:

			return { ...state, isPublishedShown: action.payload }

		default:

			return state;
	}
}
